import IAmount from "./IAmount";
import IHcImage from "@/module/main/dto/financing-v1/IHcImage";
import IItem from "@/module/main/dto/financing-v1/IItem";

export default class Item implements IItem {
    constructor(public code: string,
                public name: string,
                public quantity: number,
                public type: string,
                public producer: string,
                public totalPrice: IAmount | undefined,
                public image: IHcImage
    ) {
    }
}
